import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@repo/common';
import { DataTestIds } from '@repo/frontend-shared';
import { SDSAvatar } from '@repo/sds/SDSAvatar';
import { SDSPrimitiveButton } from '@repo/sds/SDSPrimitiveButton';
import { AvatarIconDefault } from '@repo/ui/assets/icons/AvatarIconDefault';
import { AvatarIconHover } from '@repo/ui/assets/icons/AvatarIconHover';
import { useCurrentUser } from '@repo/ui/contexts/current-user-context';
import { useDeviceType } from '@repo/ui/hooks/use-device-type';

export function AvatarButton({ profilePath = ROUTES.PROFILE }: { profilePath?: string }) {
  const { isMobileOrTablet } = useDeviceType();
  const [isHovered, setIsHovered] = useState(false);
  const [isPressed, setIsPressed] = useState(false);

  const navigate = useNavigate();

  const handleUserPageNavigate = () => {
    navigate(profilePath);
  };

  const { currentUser } = useCurrentUser();

  const thumbnailUrl = currentUser?.picture?.thumbnailUrl;

  return (
    <SDSPrimitiveButton
      onClick={handleUserPageNavigate}
      dataTestId={DataTestIds.COMMON.SIDEBAR.USER_AVATAR}
      ariaLabel={currentUser ? `${currentUser.fullName} (${currentUser.email})` : undefined}
      className="Sidebar__avatar"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => {
        setIsHovered(false);
        setIsPressed(false);
      }}
      onMouseDown={() => setIsPressed(true)}
      onMouseUp={() => setIsPressed(false)}
      style={{ position: 'relative', width: '48px', height: '48px' }}
    >
      {!isMobileOrTablet && (isPressed || isHovered) ? <AvatarIconHover /> : <AvatarIconDefault />}
      <span className="Sidebar__initials-text">
        <SDSAvatar src={thumbnailUrl} alt="thumbnail" name={currentUser?.fullName} key={thumbnailUrl} />
      </span>
    </SDSPrimitiveButton>
  );
}
